// extracted by mini-css-extract-plugin
export default {"topMenu":"menu_topMenu__dwC86","bottomMenu":"menu_bottomMenu__Mrq2f"};